module.exports = "https://cdn.hellotech.com/client-assets/phones_and_tablets_desktop_97df4eceebadfa43bf1a24ed425ac54e.png";